import { apiClient } from './apiClient';

/**
 * Usability Admin Service
 * Bietet alle Admin-API-Aufrufe für Usability-Tests (nur Superadmin)
 */

// Tasks
export const getAllTasks = async () => {
  try {
    const response = await apiClient.get('/usability/tasks');
    // apiClient gibt bereits data.data zurück, wenn { success, data } Format vorhanden
    // Stelle sicher, dass wir immer ein Array zurückgeben
    const data = Array.isArray(response) ? response : (Array.isArray(response?.data) ? response.data : []);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Laden der Aufgaben' };
  }
};

export const createTask = async (taskData) => {
  try {
    const response = await apiClient.post('/usability/tasks', taskData);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Erstellen der Aufgabe' };
  }
};

export const updateTask = async (taskId, taskData) => {
  try {
    const response = await apiClient.put(`/usability/tasks/${taskId}`, taskData);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Aktualisieren der Aufgabe' };
  }
};

export const deleteTask = async (taskId) => {
  try {
    const response = await apiClient.delete(`/usability/tasks/${taskId}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Löschen der Aufgabe' };
  }
};

// Open Questions
export const getAllOpenQuestions = async () => {
  try {
    const response = await apiClient.get('/usability/open-questions');
    const data = Array.isArray(response) ? response : (Array.isArray(response?.data) ? response.data : []);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Laden der Fragen' };
  }
};

export const createOpenQuestion = async (questionData) => {
  try {
    const response = await apiClient.post('/usability/open-questions', questionData);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Erstellen der Frage' };
  }
};

export const updateOpenQuestion = async (questionId, questionData) => {
  try {
    const response = await apiClient.put(`/usability/open-questions/${questionId}`, questionData);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Aktualisieren der Frage' };
  }
};

export const deleteOpenQuestion = async (questionId) => {
  try {
    const response = await apiClient.delete(`/usability/open-questions/${questionId}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Löschen der Frage' };
  }
};

// Evaluations
export const getAllSessions = async () => {
  try {
    const response = await apiClient.get('/usability/evaluations/sessions');
    const data = Array.isArray(response) ? response : (Array.isArray(response?.data) ? response.data : []);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Laden der Sessions' };
  }
};

export const getSessionDetail = async (sessionId) => {
  try {
    const response = await apiClient.get(`/usability/evaluations/sessions/${sessionId}`);
    return { success: true, data: response };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Laden der Session-Details' };
  }
};

export const getAggregateEvaluation = async () => {
  const response = await apiClient.get('/usability/evaluations/aggregate');
  return { success: true, data: response.data };
};

export const deleteSession = async (sessionId) => {
  try {
    const response = await apiClient.delete(`/usability/evaluations/sessions/${sessionId}`);
    return { success: true, data: response };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Löschen der Session' };
  }
};

export const markTaskResultAsCorrect = async (taskResultId) => {
  try {
    const response = await apiClient.put(`/usability/evaluations/task-results/${taskResultId}/mark-correct`);
    return { success: true, data: response };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Markieren als korrekt' };
  }
};

export const getStatistics = async () => {
  try {
    const response = await apiClient.get('/usability/evaluations/statistics');
    return { success: true, data: response };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Laden der Statistiken' };
  }
};

export const importSessions = async (sessionsData) => {
  try {
    const response = await apiClient.post('/usability/evaluations/import', { sessions: sessionsData });
    return { success: true, data: response };
  } catch (error) {
    return { success: false, error: error.message || 'Fehler beim Importieren der Sessions' };
  }
};

const usabilityAdminService = {
  getAllTasks,
  createTask,
  updateTask,
  deleteTask,
  getAllOpenQuestions,
  createOpenQuestion,
  updateOpenQuestion,
  deleteOpenQuestion,
  getAllSessions,
  getSessionDetail,
  getAggregateEvaluation,
  getStatistics,
  deleteSession,
  markTaskResultAsCorrect,
  importSessions
};

export default usabilityAdminService;
